export const ACTIONS = {
  SKU: 'sku',
  STOCK: 'stock',
  PRICE: 'price',
  AGREED_PRICE: 'agreedPrice',
  COMPARE_AT_PRICE: 'compareAtPrice',
  CODES_AUTOGENERATED: 'codesAutogenerated',
  ELECTRONIC_CODES: 'electronicCodes',
  OPTION: 'option',
  EXPIRATION_DATE: 'expirationDate',
  IS_ONLINE: 'isOnline',
} as const;
